import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import { MessageAttachmentFragmentDoc } from '../CustomerAsLawyer/CustomerAsLawyer.queries'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CourtCaseEventFragment = {
  __typename?: 'CourtCaseEvent'
  uuid: string
  title?: string | null
  createdAt: any
  date?: any | null
  eventType: Types.CourtCaseEventType
}

export type CourtCaseMessageFragment = {
  __typename?: 'Message'
  id: number
  content?: string | null
  topicQuestionnaireAnswers?: any | null
  type: Types.MessageType
  createdAt: any
  updatedAt: any
  documents?: Array<
    | {
        __typename?: 'CustomerDocument'
        checked?: boolean | null
        id: number
        name: string
        fileUrl: string
        createdAt: any
        previewImageUrl?: string | null
        fileFormat?: string | null
        documentDate?: any | null
        effective?: boolean | null
        category?: { __typename?: 'CustomerDocumentCategory'; id: number; name: string } | null
        metadata: {
          __typename?: 'MetaData'
          utilityBillCheck?: {
            __typename?: 'UtilityBillCheck'
            moveInDate?: string | null
            moveOutDate?: string | null
            sizeOfFlat?: number | null
            isCurrentAddress?: boolean | null
          } | null
        }
        identifiedClauses?: Array<{
          __typename?: 'IdentifiedClause'
          type: string
          effective: boolean
          spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
        }> | null
      }
    | {
        __typename?: 'LawyerDocument'
        id: number
        name: string
        fileUrl: string
        createdAt: any
        previewImageUrl?: string | null
        fileFormat?: string | null
        documentDate?: any | null
        effective?: boolean | null
        identifiedClauses?: Array<{
          __typename?: 'IdentifiedClause'
          type: string
          effective: boolean
          spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
        }> | null
      }
  > | null
  serviceComment?: { __typename?: 'ServiceComment'; id: number; comment: string } | null
  lawyer?: {
    __typename?: 'Lawyer'
    id: number
    profilePictureUrl: string
    firstName: string
    lastName: string
    title?: string | null
  } | null
}

export type CourtCaseCustomerFragment = {
  __typename?: 'Customer'
  id: number
  firstName?: string | null
  lastName?: string | null
  gender?: Types.Gender | null
  phone?: string | null
  validGermanMobileNumber?: string | null
  mobilePhone?: string | null
  membership?: {
    __typename?: 'Membership'
    uuid: string
    membershipTypeUid: string
    state: Types.MembershipState
    membershipNumber: string
    activatedAt: any
    lawyerId: number
    startsAt: any
    advancedFrom?: { __typename?: 'Membership'; uuid: string } | null
    product: { __typename?: 'Product'; id: number; name: string; upgradesTo?: Array<number> | null }
  } | null
  note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
}

export type CourtCaseLawyerFragment = {
  __typename?: 'Lawyer'
  id: number
  profilePictureUrl: string
  firstName: string
  lastName: string
  title?: string | null
}

export type CourtCaseFragment = {
  __typename?: 'CourtCase'
  uuid: string
  ongoing?: boolean | null
  state: Types.CourtCaseState
  createdAt: any
  chatChronic: Array<{
    __typename?: 'ChatChronicItem'
    id: number
    type: Types.ChatChronicItemType
    item:
      | {
          __typename?: 'CourtCaseEvent'
          uuid: string
          title?: string | null
          createdAt: any
          date?: any | null
          eventType: Types.CourtCaseEventType
        }
      | {
          __typename?: 'Message'
          id: number
          content?: string | null
          topicQuestionnaireAnswers?: any | null
          type: Types.MessageType
          createdAt: any
          updatedAt: any
          documents?: Array<
            | {
                __typename?: 'CustomerDocument'
                checked?: boolean | null
                id: number
                name: string
                fileUrl: string
                createdAt: any
                previewImageUrl?: string | null
                fileFormat?: string | null
                documentDate?: any | null
                effective?: boolean | null
                category?: {
                  __typename?: 'CustomerDocumentCategory'
                  id: number
                  name: string
                } | null
                metadata: {
                  __typename?: 'MetaData'
                  utilityBillCheck?: {
                    __typename?: 'UtilityBillCheck'
                    moveInDate?: string | null
                    moveOutDate?: string | null
                    sizeOfFlat?: number | null
                    isCurrentAddress?: boolean | null
                  } | null
                }
                identifiedClauses?: Array<{
                  __typename?: 'IdentifiedClause'
                  type: string
                  effective: boolean
                  spans: Array<{
                    __typename?: 'ClauseSpan'
                    text?: string | null
                    page?: number | null
                  }>
                }> | null
              }
            | {
                __typename?: 'LawyerDocument'
                id: number
                name: string
                fileUrl: string
                createdAt: any
                previewImageUrl?: string | null
                fileFormat?: string | null
                documentDate?: any | null
                effective?: boolean | null
                identifiedClauses?: Array<{
                  __typename?: 'IdentifiedClause'
                  type: string
                  effective: boolean
                  spans: Array<{
                    __typename?: 'ClauseSpan'
                    text?: string | null
                    page?: number | null
                  }>
                }> | null
              }
          > | null
          serviceComment?: { __typename?: 'ServiceComment'; id: number; comment: string } | null
          lawyer?: {
            __typename?: 'Lawyer'
            id: number
            profilePictureUrl: string
            firstName: string
            lastName: string
            title?: string | null
          } | null
        }
  }>
  customer: {
    __typename?: 'Customer'
    id: number
    firstName?: string | null
    lastName?: string | null
    gender?: Types.Gender | null
    phone?: string | null
    validGermanMobileNumber?: string | null
    mobilePhone?: string | null
    membership?: {
      __typename?: 'Membership'
      uuid: string
      membershipTypeUid: string
      state: Types.MembershipState
      membershipNumber: string
      activatedAt: any
      lawyerId: number
      startsAt: any
      advancedFrom?: { __typename?: 'Membership'; uuid: string } | null
      product: {
        __typename?: 'Product'
        id: number
        name: string
        upgradesTo?: Array<number> | null
      }
    } | null
    note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
  }
  assignedLawyer?: {
    __typename?: 'Lawyer'
    id: number
    profilePictureUrl: string
    firstName: string
    lastName: string
    title?: string | null
  } | null
  documents: Array<
    | { __typename?: 'CustomerDocument'; id: number; name: string; fileUrl: string }
    | { __typename?: 'LawyerDocument'; id: number; name: string; fileUrl: string }
  >
}

export type CourtCaseQueryVariables = Types.Exact<{
  customerId: Types.Scalars['Int']
  uuid: Types.Scalars['String']
}>

export type CourtCaseQuery = {
  __typename?: 'Query'
  courtCases: {
    __typename?: 'CourtCasesCollection'
    items: Array<{
      __typename?: 'CourtCase'
      uuid: string
      ongoing?: boolean | null
      state: Types.CourtCaseState
      createdAt: any
      chatChronic: Array<{
        __typename?: 'ChatChronicItem'
        id: number
        type: Types.ChatChronicItemType
        item:
          | {
              __typename?: 'CourtCaseEvent'
              uuid: string
              title?: string | null
              createdAt: any
              date?: any | null
              eventType: Types.CourtCaseEventType
            }
          | {
              __typename?: 'Message'
              id: number
              content?: string | null
              topicQuestionnaireAnswers?: any | null
              type: Types.MessageType
              createdAt: any
              updatedAt: any
              documents?: Array<
                | {
                    __typename?: 'CustomerDocument'
                    checked?: boolean | null
                    id: number
                    name: string
                    fileUrl: string
                    createdAt: any
                    previewImageUrl?: string | null
                    fileFormat?: string | null
                    documentDate?: any | null
                    effective?: boolean | null
                    category?: {
                      __typename?: 'CustomerDocumentCategory'
                      id: number
                      name: string
                    } | null
                    metadata: {
                      __typename?: 'MetaData'
                      utilityBillCheck?: {
                        __typename?: 'UtilityBillCheck'
                        moveInDate?: string | null
                        moveOutDate?: string | null
                        sizeOfFlat?: number | null
                        isCurrentAddress?: boolean | null
                      } | null
                    }
                    identifiedClauses?: Array<{
                      __typename?: 'IdentifiedClause'
                      type: string
                      effective: boolean
                      spans: Array<{
                        __typename?: 'ClauseSpan'
                        text?: string | null
                        page?: number | null
                      }>
                    }> | null
                  }
                | {
                    __typename?: 'LawyerDocument'
                    id: number
                    name: string
                    fileUrl: string
                    createdAt: any
                    previewImageUrl?: string | null
                    fileFormat?: string | null
                    documentDate?: any | null
                    effective?: boolean | null
                    identifiedClauses?: Array<{
                      __typename?: 'IdentifiedClause'
                      type: string
                      effective: boolean
                      spans: Array<{
                        __typename?: 'ClauseSpan'
                        text?: string | null
                        page?: number | null
                      }>
                    }> | null
                  }
              > | null
              serviceComment?: { __typename?: 'ServiceComment'; id: number; comment: string } | null
              lawyer?: {
                __typename?: 'Lawyer'
                id: number
                profilePictureUrl: string
                firstName: string
                lastName: string
                title?: string | null
              } | null
            }
      }>
      customer: {
        __typename?: 'Customer'
        id: number
        firstName?: string | null
        lastName?: string | null
        gender?: Types.Gender | null
        phone?: string | null
        validGermanMobileNumber?: string | null
        mobilePhone?: string | null
        membership?: {
          __typename?: 'Membership'
          uuid: string
          membershipTypeUid: string
          state: Types.MembershipState
          membershipNumber: string
          activatedAt: any
          lawyerId: number
          startsAt: any
          advancedFrom?: { __typename?: 'Membership'; uuid: string } | null
          product: {
            __typename?: 'Product'
            id: number
            name: string
            upgradesTo?: Array<number> | null
          }
        } | null
        note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
      }
      assignedLawyer?: {
        __typename?: 'Lawyer'
        id: number
        profilePictureUrl: string
        firstName: string
        lastName: string
        title?: string | null
      } | null
      documents: Array<
        | { __typename?: 'CustomerDocument'; id: number; name: string; fileUrl: string }
        | { __typename?: 'LawyerDocument'; id: number; name: string; fileUrl: string }
      >
    }>
  }
}

export const CourtCaseEventFragmentDoc = gql`
  fragment CourtCaseEvent on CourtCaseEvent {
    uuid
    title
    eventType: type
    createdAt
    date
  }
`
export const CourtCaseLawyerFragmentDoc = gql`
  fragment CourtCaseLawyer on Lawyer {
    id
    profilePictureUrl
    firstName
    lastName
    title
  }
`
export const CourtCaseMessageFragmentDoc = gql`
  fragment CourtCaseMessage on Message {
    id
    content
    documents {
      ...MessageAttachment
    }
    serviceComment {
      id
      comment
    }
    lawyer {
      ...CourtCaseLawyer
    }
    topicQuestionnaireAnswers
    type
    createdAt
    updatedAt
  }
  ${MessageAttachmentFragmentDoc}
  ${CourtCaseLawyerFragmentDoc}
`
export const CourtCaseCustomerFragmentDoc = gql`
  fragment CourtCaseCustomer on Customer {
    id
    firstName
    lastName
    gender
    phone
    validGermanMobileNumber
    mobilePhone
    membership {
      uuid
      membershipTypeUid
      state
      membershipNumber
      activatedAt
      advancedFrom {
        uuid
      }
      lawyerId
      startsAt
      product {
        id
        name
        upgradesTo
      }
    }
    note {
      id
      note
    }
  }
`
export const CourtCaseFragmentDoc = gql`
  fragment CourtCase on CourtCase {
    uuid
    chatChronic {
      id
      item {
        ... on CourtCaseEvent {
          ...CourtCaseEvent
        }
        ... on Message {
          ...CourtCaseMessage
        }
      }
      type
    }
    customer {
      ...CourtCaseCustomer
    }
    assignedLawyer {
      ...CourtCaseLawyer
    }
    documents {
      id
      name
      fileUrl
    }
    ongoing
    state
    createdAt
  }
  ${CourtCaseEventFragmentDoc}
  ${CourtCaseMessageFragmentDoc}
  ${CourtCaseCustomerFragmentDoc}
  ${CourtCaseLawyerFragmentDoc}
`
export const CourtCaseDocument = gql`
  query CourtCase($customerId: Int!, $uuid: String!) {
    courtCases(filters: { customerId: { equals: $customerId }, uuid: { equals: $uuid } }) {
      items {
        ...CourtCase
      }
    }
  }
  ${CourtCaseFragmentDoc}
`
export function useCourtCaseQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<CourtCaseQuery, CourtCaseQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CourtCaseQuery, CourtCaseQueryVariables>(
    CourtCaseDocument,
    options
  )
}
export function useCourtCaseLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourtCaseQuery, CourtCaseQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CourtCaseQuery, CourtCaseQueryVariables>(
    CourtCaseDocument,
    options
  )
}
export type CourtCaseQueryHookResult = ReturnType<typeof useCourtCaseQuery>
export type CourtCaseLazyQueryHookResult = ReturnType<typeof useCourtCaseLazyQuery>
export type CourtCaseQueryResult = ApolloReactCommon.QueryResult<
  CourtCaseQuery,
  CourtCaseQueryVariables
>
export function refetchCourtCaseQuery(variables?: CourtCaseQueryVariables) {
  return { query: CourtCaseDocument, variables: variables }
}
